import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';

import NewsLetter from './NewsLetter';

import Logo from '../assets/img/Waleed-Logo.gif';
import FooterIcon1 from '../assets/img/nav-icon1.svg';
import FooterIcon2 from '../assets/img/nav-icon2.svg';
import FooterIcon3 from '../assets/img/nav-icon3.svg';

const Footer = () => {
    return (
        <footer className='footer'>
            <Container>
                <Row className='align-item-center'>
                    <NewsLetter />
                    <Col sm={6}>
                        <img src={Logo} alt="Footer Logo" />
                    </Col>
                    <Col sm={6} className="text-center text-sm-end">
                        <div className='social-icon'>
                            <a href="https://www.linkedin.com/in/myselfswk/" target={'_blank'}><img src={FooterIcon1} alt="LinkedIn" /></a>
                            <a href="https://www.facebook.com/myselfswk" target={'_blank'}><img src={FooterIcon2} alt="Facebook" /></a>
                            <a href="https://www.instagram.com/myselfswk/" target={'_blank'}><img src={FooterIcon3} alt="Instagram" /></a>
                        </div>
                        <p>@CopyRight 2023, All Right Reserved.</p>
                    </Col>
                </Row>
            </Container>
        </footer>
    )
}

export default Footer;